import { CheckIcon, CopyIcon, ExternalLinkIcon } from '@radix-ui/react-icons';
import { Box, Button, DropdownMenu, Flex, Text } from '@workos-inc/design-system';
import * as React from 'react';
import { useKeysQuery, UsersOrganizationsRole } from 'src/graphql/generated';
import { useCurrentSession, useUser } from 'src/queries';
import { BACKEND_STACK, FRONTEND_STACK } from 'src/utils/stack-selection';
interface CopyMarkdownButtonProps {
  slug: string[];
}
type CopyStatus = 'idle' | 'loading' | 'copied' | 'error';
const MarkdownIcon = () => <svg fill="none" height="15" viewBox="0 0 18 18" width="15" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="MarkdownIcon" data-sentry-source-file="copy-markdown-button.tsx">
    <path d="M15.25 3.75H2.75C1.64543 3.75 0.75 4.64543 0.75 5.75V12.25C0.75 13.3546 1.64543 14.25 2.75 14.25H15.25C16.3546 14.25 17.25 13.3546 17.25 12.25V5.75C17.25 4.64543 16.3546 3.75 15.25 3.75Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
    <path d="M8.75 11.25V6.75H8.356L6.25 9.5L4.144 6.75H3.75V11.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
    <path d="M11.5 9.5L13.25 11.25L15 9.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
    <path d="M13.25 11.25V6.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
  </svg>;
const OpenAIIcon = () => <svg fill="currentColor" fillRule="evenodd" height="15" viewBox="0 0 24 24" width="15" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="OpenAIIcon" data-sentry-source-file="copy-markdown-button.tsx">
    <path d="M21.55 10.004a5.416 5.416 0 00-.478-4.501c-1.217-2.09-3.662-3.166-6.05-2.66A5.59 5.59 0 0010.831 1C8.39.995 6.224 2.546 5.473 4.838A5.553 5.553 0 001.76 7.496a5.487 5.487 0 00.691 6.5 5.416 5.416 0 00.477 4.502c1.217 2.09 3.662 3.165 6.05 2.66A5.586 5.586 0 0013.168 23c2.443.006 4.61-1.546 5.361-3.84a5.553 5.553 0 003.715-2.66 5.488 5.488 0 00-.693-6.497v.001zm-8.381 11.558a4.199 4.199 0 01-2.675-.954c.034-.018.093-.05.132-.074l4.44-2.53a.71.71 0 00.364-.623v-6.176l1.877 1.069c.02.01.033.029.036.05v5.115c-.003 2.274-1.87 4.118-4.174 4.123zM4.192 17.78a4.059 4.059 0 01-.498-2.763c.032.02.09.055.131.078l4.44 2.53c.225.13.504.13.73 0l5.42-3.088v2.138a.068.068 0 01-.027.057L9.9 19.288c-1.999 1.136-4.552.46-5.707-1.51h-.001zM3.023 8.216A4.15 4.15 0 015.198 6.41l-.002.151v5.06a.711.711 0 00.364.624l5.42 3.087-1.876 1.07a.067.067 0 01-.063.005l-4.489-2.559c-1.995-1.14-2.679-3.658-1.53-5.63h.001zm15.417 3.54l-5.42-3.088L14.896 7.6a.067.067 0 01.063-.006l4.489 2.557c1.998 1.14 2.683 3.662 1.529 5.633a4.163 4.163 0 01-2.174 1.807V12.38a.71.71 0 00-.363-.623zm1.867-2.773a6.04 6.04 0 00-.132-.078l-4.44-2.53a.731.731 0 00-.729 0l-5.42 3.088V7.325a.068.068 0 01.027-.057L14.1 4.713c2-1.137 4.555-.46 5.707 1.513.487.833.664 1.809.499 2.757h.001zm-11.741 3.81l-1.877-1.068a.065.065 0 01-.036-.051V6.559c.001-2.277 1.873-4.122 4.181-4.12.976 0 1.92.338 2.671.954-.034.018-.092.05-.131.073l-4.44 2.53a.71.71 0 00-.365.623l-.003 6.173v.002zm1.02-2.168L12 9.25l2.414 1.375v2.75L12 14.75l-2.415-1.375v-2.75z" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
  </svg>;
const ClaudeIcon = () => <svg fill="currentColor" fillRule="evenodd" height="15" viewBox="0 0 256 257" width="15" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="ClaudeIcon" data-sentry-source-file="copy-markdown-button.tsx">
    <path d="m50.228 170.321 50.357-28.257.843-2.463-.843-1.361h-2.462l-8.426-.518-28.775-.778-24.952-1.037-24.175-1.296-6.092-1.297L0 125.796l.583-3.759 5.12-3.434 7.324.648 16.202 1.101 24.304 1.685 17.629 1.037 26.118 2.722h4.148l.583-1.685-1.426-1.037-1.101-1.037-25.147-17.045-27.22-18.017-14.258-10.37-7.713-5.25-3.888-4.925-1.685-10.758 7-7.713 9.397.649 2.398.648 9.527 7.323 20.35 15.75L94.817 91.9l3.889 3.24 1.555-1.102.195-.777-1.75-2.917-14.453-26.118-15.425-26.572-6.87-11.018-1.814-6.61c-.648-2.723-1.102-4.991-1.102-7.778l7.972-10.823L71.42 0 82.05 1.426l4.472 3.888 6.61 15.101 10.694 23.786 16.591 32.34 4.861 9.592 2.592 8.879.973 2.722h1.685v-1.556l1.36-18.211 2.528-22.36 2.463-28.776.843-8.1 4.018-9.722 7.971-5.25 6.222 2.981 5.12 7.324-.713 4.73-3.046 19.768-5.962 30.98-3.889 20.739h2.268l2.593-2.593 10.499-13.934 17.628-22.036 7.778-8.749 9.073-9.657 5.833-4.601h11.018l8.1 12.055-3.628 12.443-11.342 14.388-9.398 12.184-13.48 18.147-8.426 14.518.778 1.166 2.01-.194 30.46-6.481 16.462-2.982 19.637-3.37 8.88 4.148.971 4.213-3.5 8.62-20.998 5.184-24.628 4.926-36.682 8.685-.454.324.519.648 16.526 1.555 7.065.389h17.304l32.21 2.398 8.426 5.574 5.055 6.805-.843 5.184-12.962 6.611-17.498-4.148-40.83-9.721-14-3.5h-1.944v1.167l11.666 11.406 21.387 19.314 26.767 24.887 1.36 6.157-3.434 4.86-3.63-.518-23.526-17.693-9.073-7.972-20.545-17.304h-1.36v1.814l4.73 6.935 25.017 37.59 1.296 11.536-1.814 3.76-6.481 2.268-7.13-1.297-14.647-20.544-15.1-23.138-12.185-20.739-1.49.843-7.194 77.448-3.37 3.953-7.778 2.981-6.48-4.925-3.436-7.972 3.435-15.749 4.148-20.544 3.37-16.333 3.046-20.285 1.815-6.74-.13-.454-1.49.194-15.295 20.999-23.267 31.433-18.406 19.702-4.407 1.75-7.648-3.954.713-7.064 4.277-6.286 25.47-32.405 15.36-20.092 9.917-11.6-.065-1.686h-.583L44.07 198.125l-12.055 1.555-5.185-4.86.648-7.972 2.463-2.593 20.35-13.999-.064.065Z" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
  </svg>;
const PerplexityIcon = () => <svg fill="currentColor" height="15" viewBox="0 0 34 38" width="15" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="PerplexityIcon" data-sentry-source-file="copy-markdown-button.tsx">
    <path clipRule="evenodd" d="M5.12114 0.0400391L15.919 9.98864V9.98636V0.062995H18.0209V10.0332L28.8671 0.0400391V11.3829H33.3202V27.744H28.8808V37.8442L18.0209 28.303V37.9538H15.919V28.4604L5.13338 37.96V27.744H0.680176V11.3829H5.12114V0.0400391ZM14.3344 13.4592H2.78208V25.6677H5.13074V21.8167L14.3344 13.4592ZM7.23518 22.7379V33.3271L15.919 25.6786V14.8506L7.23518 22.7379ZM18.0814 25.5775V14.8404L26.7677 22.7282V27.744H26.7789V33.219L18.0814 25.5775ZM28.8808 25.6677H31.2183V13.4592H19.752L28.8808 21.7302V25.6677ZM26.7652 11.3829V4.81584L19.6374 11.3829H26.7652ZM14.3507 11.3829H7.22306V4.81584L14.3507 11.3829Z" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
  </svg>;
const CursorIcon = () => <svg fill="currentColor" height="15" viewBox="0 0 24 24" width="15" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="CursorIcon" data-sentry-source-file="copy-markdown-button.tsx">
    <path d="M21.582 5.68 11.997.134a.994.994 0 0 0-.995 0L1.418 5.681A.84.84 0 0 0 1 6.407v11.186c0 .3.16.577.418.726l9.585 5.547a.994.994 0 0 0 .995 0l9.584-5.547a.84.84 0 0 0 .418-.726V6.407a.84.84 0 0 0-.418-.726Zm-.602 1.176L11.727 22.92c-.062.108-.227.064-.227-.061v-10.52a.59.59 0 0 0-.294-.51L2.119 6.57c-.108-.062-.064-.228.061-.228h18.504c.263 0 .427.286.296.514Z" data-sentry-element="path" data-sentry-source-file="copy-markdown-button.tsx" />
  </svg>;
function getCopyButtonText(status: CopyStatus) {
  switch (status) {
    case 'loading':
      return 'Copying...';
    case 'copied':
      return 'Copied';
    case 'idle':
    default:
      return 'Copy page';
  }
}

// NOTE: this cannot be copied to an async function because it needs to
// be called synchronously to satisfy the Clipboard API in Safari.
function copyToClipboard(path: string) {
  const fetchPromise = fetch(path).then(response => {
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }
    return response.text();
  });
  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard.write) {
    const text = new ClipboardItem({
      'text/plain': fetchPromise.then(text => new Blob([text], {
        type: 'text/plain'
      }))
    });
    return navigator.clipboard.write([text]);
  } else {
    return fetchPromise.then(text => navigator.clipboard.writeText(text));
  }
}

/**
 * Extract frontend and backend stack from slug if present.
 * For authkit pages, the URL pattern is /authkit/{frontend}/{backend}
 */
function getStackFromSlug(slug: string[]): {
  frontend: string | null;
  backend: string | null;
} {
  // Only extract stack for authkit pages
  if (slug[0] !== 'authkit') {
    return {
      frontend: null,
      backend: null
    };
  }
  const potentialFrontend = slug[1];
  const potentialBackend = slug[2];
  const frontend = potentialFrontend && potentialFrontend in FRONTEND_STACK ? potentialFrontend : 'vanilla';
  const backend = potentialBackend && potentialBackend in BACKEND_STACK ? potentialBackend : 'nodejs';
  return {
    frontend,
    backend
  };
}
interface MenuItemContentProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  showExternalIcon?: boolean;
}
const MenuItemContent = ({
  icon,
  title,
  description,
  showExternalIcon = false
}: MenuItemContentProps) => <Flex align="center" flexGrow="1" gap="2" data-sentry-element="Flex" data-sentry-component="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx">
    <Box data-sentry-element="Box" data-sentry-source-file="copy-markdown-button.tsx">{icon}</Box>
    <Flex direction="column" flexGrow="1" data-sentry-element="Flex" data-sentry-source-file="copy-markdown-button.tsx">
      <Text size="2" data-sentry-element="Text" data-sentry-source-file="copy-markdown-button.tsx">{title}</Text>
      {description && <Text color="gray" size="1">
          {description}
        </Text>}
    </Flex>
    {showExternalIcon && <ExternalLinkIcon color="var(--gray-10)" height={16} width={16} />}
  </Flex>;
export function CopyMarkdownButton({
  slug
}: CopyMarkdownButtonProps) {
  const [copyStatus, setCopyStatus] = React.useState<CopyStatus>('idle');
  const [hasOpenedDropdown, setHasOpenedDropdown] = React.useState(false);
  // Cache for prefetched markdown content
  const cachedMarkdown = React.useRef<{
    path: string;
    content: string;
  } | null>(null);

  // Fetch user session data for token replacements
  const {
    data: currentProject
  } = useCurrentSession({
    select: session => session.currentEnvironment.project
  });
  const {
    data: isSupportRole = true
  } = useUser({
    select: me => me.teamMemberships[0]?.role === UsersOrganizationsRole.Support
  });
  const firstSandboxEnvironment = currentProject?.environments[0];
  const {
    data: defaultKey
  } = useKeysQuery({
    environmentId: firstSandboxEnvironment?.id ?? ''
  }, {
    staleTime: Infinity,
    select: data => data.keys.data[0],
    enabled: Boolean(firstSandboxEnvironment?.id && !isSupportRole)
  });
  const getMarkdownPath = React.useCallback((includeSecrets = false) => {
    // Extract stack from slug and pass as query params
    const {
      frontend,
      backend
    } = getStackFromSlug(slug);
    const queryParams = new URLSearchParams();
    if (frontend) {
      queryParams.set('frontend', frontend);
    }
    if (backend) {
      queryParams.set('backend', backend);
    }

    // Add token replacement values if available
    if (firstSandboxEnvironment?.clientId && includeSecrets) {
      queryParams.set('clientId', firstSandboxEnvironment.clientId);
    }
    if (!isSupportRole && defaultKey?.displayValue && includeSecrets) {
      queryParams.set('secretKey', defaultKey.displayValue);
    }
    const authkitDomain = firstSandboxEnvironment?.preferredAuthkitDomain?.domain;
    if (authkitDomain && includeSecrets) {
      queryParams.set('authkitDomain', authkitDomain);
    }
    const queryString = queryParams.toString();
    return `/docs/api/markdown/${slug.join('/')}${queryString ? `?${queryString}` : ''}`;
  }, [slug, firstSandboxEnvironment, isSupportRole, defaultKey]);
  const getMarkdownUrl = React.useCallback(() => {
    if (typeof window === 'undefined') {
      return '';
    }
    return `${window.location.origin}${getMarkdownPath()}`;
  }, [getMarkdownPath]);

  // Prefetch markdown when dropdown opens
  React.useEffect(() => {
    if (!hasOpenedDropdown) {
      return;
    }
    const path = getMarkdownPath(true);

    // Skip if already cached for this path
    if (cachedMarkdown.current?.path === path) {
      return;
    }
    const abortController = new AbortController();
    fetch(path, {
      signal: abortController.signal
    }).then(response => {
      if (response.ok) {
        return response.text();
      }
      return null;
    }).then(text => {
      if (text) {
        cachedMarkdown.current = {
          path,
          content: text
        };
      }
    }).catch(() => {
      // Ignore errors (including abort)
    });
    return () => {
      abortController.abort();
    };
  }, [hasOpenedDropdown, getMarkdownPath]);
  const handleCopy = async () => {
    setCopyStatus('loading');
    try {
      const path = getMarkdownPath(true);

      // Use cached content if available for this path
      if (cachedMarkdown.current?.path === path) {
        await navigator.clipboard.writeText(cachedMarkdown.current.content);
      } else {
        // Fall back to fetching (handles Safari clipboard API)
        await copyToClipboard(path);
      }
      setCopyStatus('copied');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Copy failed:', err);
      setCopyStatus('error');
    } finally {
      setTimeout(() => setCopyStatus('idle'), 2000);
    }
  };
  const handleViewAsMarkdown = () => {
    window.open(getMarkdownPath(), '_blank');
  };
  const handleOpenInChatGPT = () => {
    const markdownUrl = getMarkdownUrl();
    const prompt = encodeURIComponent(`I have a question about this documentation page: ${markdownUrl}`);
    window.open(`https://chatgpt.com/?q=${prompt}`, '_blank');
  };
  const handleOpenInClaude = () => {
    const markdownUrl = getMarkdownUrl();
    const prompt = encodeURIComponent(`I have a question about this documentation page: ${markdownUrl}`);
    window.open(`https://claude.ai/new?q=${prompt}`, '_blank');
  };
  const handleOpenInPerplexity = () => {
    const markdownUrl = getMarkdownUrl();
    const prompt = encodeURIComponent(`I have a question about this documentation page: ${markdownUrl}`);
    window.open(`https://www.perplexity.ai/?q=${prompt}`, '_blank');
  };
  const handleOpenInCursor = () => {
    const markdownUrl = getMarkdownUrl();
    const prompt = encodeURIComponent(`I have a question about this documentation page: ${markdownUrl}`);
    window.open(`https://cursor.com/link/prompt?text=${prompt}`);
  };
  const copyText = getCopyButtonText(copyStatus);
  let errorMessage: string | undefined;
  if (copyStatus === 'error') {
    errorMessage = 'Please refresh page and try again';
  }
  const handleDropdownOpenChange = React.useCallback((open: boolean) => {
    if (open && !hasOpenedDropdown) {
      setHasOpenedDropdown(true);
    }
  }, [hasOpenedDropdown]);
  return <>
      <DropdownMenu.Root onOpenChange={handleDropdownOpenChange} data-sentry-element="DropdownMenu.Root" data-sentry-source-file="copy-markdown-button.tsx">
        <DropdownMenu.Trigger data-sentry-element="DropdownMenu.Trigger" data-sentry-source-file="copy-markdown-button.tsx">
          <Button className="copy-markdown-button" data-disabled={copyStatus === 'loading' || undefined} data-sentry-element="Button" data-sentry-source-file="copy-markdown-button.tsx">
            {copyStatus === 'copied' ? <CheckIcon /> : <CopyIcon />}
            {copyText}
            <DropdownMenu.TriggerIcon data-sentry-element="DropdownMenu.TriggerIcon" data-sentry-source-file="copy-markdown-button.tsx" />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="start" data-sentry-element="DropdownMenu.Content" data-sentry-source-file="copy-markdown-button.tsx">
          <DropdownMenu.Item disabled={copyStatus === 'loading' || copyStatus === 'copied'} onClick={handleCopy} data-sentry-element="DropdownMenu.Item" data-sentry-source-file="copy-markdown-button.tsx">
            <MenuItemContent icon={copyStatus === 'copied' ? <CheckIcon /> : <CopyIcon />} title="Copy page as Markdown" data-sentry-element="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx" />
          </DropdownMenu.Item>

          <DropdownMenu.Item onClick={handleViewAsMarkdown} data-sentry-element="DropdownMenu.Item" data-sentry-source-file="copy-markdown-button.tsx">
            <MenuItemContent showExternalIcon icon={<MarkdownIcon />} title="View Markdown" data-sentry-element="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx" />
          </DropdownMenu.Item>

          <DropdownMenu.Separator data-sentry-element="DropdownMenu.Separator" data-sentry-source-file="copy-markdown-button.tsx" />

          <DropdownMenu.Item onClick={handleOpenInChatGPT} data-sentry-element="DropdownMenu.Item" data-sentry-source-file="copy-markdown-button.tsx">
            <MenuItemContent showExternalIcon icon={<OpenAIIcon />} title="Open in ChatGPT" data-sentry-element="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx" />
          </DropdownMenu.Item>

          <DropdownMenu.Item onClick={handleOpenInClaude} data-sentry-element="DropdownMenu.Item" data-sentry-source-file="copy-markdown-button.tsx">
            <MenuItemContent showExternalIcon icon={<ClaudeIcon />} title="Open in Claude" data-sentry-element="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx" />
          </DropdownMenu.Item>

          <DropdownMenu.Item onClick={handleOpenInCursor} data-sentry-element="DropdownMenu.Item" data-sentry-source-file="copy-markdown-button.tsx">
            <MenuItemContent showExternalIcon icon={<CursorIcon />} title="Open in Cursor" data-sentry-element="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx" />
          </DropdownMenu.Item>

          <DropdownMenu.Item onClick={handleOpenInPerplexity} data-sentry-element="DropdownMenu.Item" data-sentry-source-file="copy-markdown-button.tsx">
            <MenuItemContent showExternalIcon icon={<PerplexityIcon />} title="Open in Perplexity" data-sentry-element="MenuItemContent" data-sentry-source-file="copy-markdown-button.tsx" />
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
      <Flex direction="column" gap={{
      initial: '3',
      xs: '5'
    }} justify="between" pt="2" data-sentry-element="Flex" data-sentry-source-file="copy-markdown-button.tsx">
        <Box height="16px" data-sentry-element="Box" data-sentry-source-file="copy-markdown-button.tsx">
          {errorMessage && <Text color="red" size="2" trim="start">
              {errorMessage}
            </Text>}
        </Box>
      </Flex>
    </>;
}